import type { NotificationFeedItem } from '@om/shared-types';
import { apiClient } from './client';

class NotificationApiService {
  async list(limit: number = 20, celebrationId?: number): Promise<NotificationFeedItem[]> {
    const params: Record<string, number> = { limit };
    if (celebrationId) {
      params.celebrationId = celebrationId;
    }

    const response = await apiClient.get<{ success: boolean; data: NotificationFeedItem[] }>('/notifications', {
      params,
    });

    return response.data.data;
  }

  async markRead(celebrationId?: number): Promise<number> {
    const response = await apiClient.post<{ success: boolean; data: { markedCount: number } }>('/notifications/read', {
      celebrationId,
    });

    return response.data.data.markedCount;
  }

  async markOneRead(recipientId: number): Promise<boolean> {
    const response = await apiClient.post<{ success: boolean; data: { marked: boolean } }>(
      `/notifications/${recipientId}/read`,
      {},
    );

    return response.data.data.marked;
  }
}

export const notificationApiService = new NotificationApiService();
